export default __webpack_public_path__ + "static/media/Oxford.8259cc7d.png";